export function createBannerInHtmlPersonaState(nudgeData) {
    return {
        nudgeOfferText: {
            text: nudgeData?.nudgeOfferText?.customizeProperties?.text
                ?.propertyValue,
            textColor:
                nudgeData?.nudgeOfferText?.customizeProperties?.textColor
                    ?.propertyValue,
            fontStyle:
                nudgeData?.nudgeOfferText?.customizeProperties?.fontStyle
                    ?.propertyValue,
            isExpiryTimer: nudgeData?.nudgeOfferText?.customizeProperties?.isExpiryTimer?.propertyValue,
            minutes: nudgeData?.nudgeOfferText?.customizeProperties?.minutes?.propertyValue,
        },
        nudgeCouponCode: {
            text: nudgeData?.nudgeCouponCode?.customizeProperties?.text
                ?.propertyValue,
            textColor:
                nudgeData?.nudgeCouponCode?.customizeProperties?.textColor
                    ?.propertyValue,
            backgroundColor:
                nudgeData?.nudgeCouponCode?.customizeProperties?.backgroundColor
                    ?.propertyValue,
            fontStyle:
                nudgeData?.nudgeCouponCode?.customizeProperties?.fontStyle
                    ?.propertyValue,
            borderStyle:
                nudgeData?.nudgeCouponCode?.customizeProperties?.borderStyle
                    ?.propertyValue,
            borderColor:
                nudgeData?.nudgeCouponCode?.customizeProperties?.borderColor
                    ?.propertyValue,
            borderWidth:
                nudgeData?.nudgeCouponCode?.customizeProperties?.borderWidth
                    ?.propertyValue,
            borderRadius:
                nudgeData?.nudgeCouponCode?.customizeProperties?.borderRadius
                    ?.propertyValue,
            display:
                    nudgeData?.nudgeCouponCode?.customizeProperties?.display
                        ?.propertyValue,
        },
        nudgeCopyCode: {
            text: nudgeData?.nudgeCopyCode?.customizeProperties?.text
                ?.propertyValue,
            textColor:
                nudgeData?.nudgeCopyCode?.customizeProperties?.textColor
                    ?.propertyValue,
            backgroundColor:
                nudgeData?.nudgeCopyCode?.customizeProperties?.backgroundColor
                    ?.propertyValue,
            fontStyle:
                nudgeData?.nudgeCopyCode?.customizeProperties?.fontStyle
                    ?.propertyValue,
            borderStyle:
                nudgeData?.nudgeCopyCode?.customizeProperties?.borderStyle
                    ?.propertyValue,
            borderColor:
                nudgeData?.nudgeCopyCode?.customizeProperties?.borderColor
                    ?.propertyValue,
            borderWidth:
                nudgeData?.nudgeCopyCode?.customizeProperties?.borderWidth
                    ?.propertyValue,
            borderRadius:
                    nudgeData?.nudgeCopyCode?.customizeProperties?.borderRadius
                    ?.propertyValue,
            ...(nudgeData.nudgeCopyCode.customizeProperties.href && {
                        href: nudgeData.nudgeCopyCode.customizeProperties.href?.propertyValue,
                    })
        },
        nudge: {
            backgroundColor:
                nudgeData?.nudge?.customizeProperties?.backgroundColor
                    ?.propertyValue,
            borderColor:
                nudgeData?.nudge?.customizeProperties?.borderColor?.propertyValue,
            borderStyle:
                nudgeData?.nudge?.customizeProperties?.borderStyle?.propertyValue,
            borderWidth:
                nudgeData?.nudge?.customizeProperties?.borderWidth?.propertyValue,
            borderRadius:
                nudgeData?.nudge?.customizeProperties?.borderRadius?.propertyValue,
            desktopNudgePosition: {
                top: nudgeData?.nudge?.nudgePosition?.desktop?.top,
                left: nudgeData?.nudge?.nudgePosition?.desktop?.left,
            },
            mobileNudgePosition: {
                top: nudgeData?.nudge?.nudgePosition?.mobile?.top,
            },
        },
        nudgeShowing: {
            allowed:nudgeData?.nudgeShowing?.customizeProperties?.allowed?.propertyValue,
            prohibited: nudgeData?.nudgeShowing?.customizeProperties?.prohibited?.propertyValue,
            status: nudgeData?.nudgeShowing?.customizeProperties?.status?.propertyValue,
            firstTimeNudgeShown: nudgeData?.nudgeShowing?.customizeProperties?.firstTimeNudgeShown?.propertyValue,
            sensitivity: nudgeData?.nudgeShowing?.customizeProperties?.sensitivity?.propertyValue,
            device:nudgeData?.nudgeShowing?.customizeProperties?.device?.propertyValue ?? "all",
            Geolocation: nudgeData?.nudgeShowing?.customizeProperties?.Geolocation?.propertyValue,
            nudgeTimeout: nudgeData?.nudgeShowing?.customizeProperties?.nudgeTimeout?.propertyValue,
            audience:nudgeData?.nudgeShowing?.customizeProperties?.audience?.propertyValue,
            ...(nudgeData.nudgeShowing.customizeProperties.endDate && {
                endDate: nudgeData.nudgeShowing.customizeProperties.endDate?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.nudgeActiveDays && {
                nudgeActiveDays: nudgeData.nudgeShowing.customizeProperties.nudgeActiveDays?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.GeoZipcodes && {
                GeoZipcodes: nudgeData.nudgeShowing.customizeProperties.GeoZipcodes?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.BlacklistedZipcodes && {
                BlacklistedZipcodes: nudgeData.nudgeShowing.customizeProperties.BlacklistedZipcodes?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.seoKeyword && {
                seoKeyword: nudgeData.nudgeShowing.customizeProperties.seoKeyword?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.ipBasedNudgeControl && {
                ipBasedNudgeControl: nudgeData.nudgeShowing.customizeProperties.ipBasedNudgeControl?.propertyValue,
            }),
            ...(nudgeData.nudgeShowing.customizeProperties.firstTimeUserCheckingOptions && {
                firstTimeUserCheckingOptions: nudgeData.nudgeShowing.customizeProperties.firstTimeUserCheckingOptions?.propertyValue,
            }),
        },
        nudgeClosed: {
            fontSize:nudgeData?.nudgeClosed?.customizeProperties?.fontSize?.propertyValue,
            textColor: nudgeData?.nudgeClosed?.customizeProperties?.textColor?.propertyValue,
            topPosition:nudgeData?.nudgeClosed?.customizeProperties?.topPosition?.propertyValue,
            rightPosition:nudgeData?.nudgeClosed?.customizeProperties?.rightPosition?.propertyValue
        },
        nudgeTrafficSources: {    
            referrerSites:nudgeData?.nudgeTrafficSources?.customizeProperties?.referrerSites?.propertyValue,
        },
        nudgePosition: {
            placement:nudgeData?.nudgePosition?.customizeProperties?.placement?.propertyValue,
            margin_left:nudgeData?.nudgePosition?.customizeProperties?.margin_left?.propertyValue,
            margin_top:nudgeData?.nudgePosition?.customizeProperties?.margin_top?.propertyValue,
            margin_right:nudgeData?.nudgePosition?.customizeProperties?.margin_right?.propertyValue,
            margin_bottom:nudgeData?.nudgePosition?.customizeProperties?.margin_bottom?.propertyValue,
        },
    }
}